"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BureauScoreOverview = exports.LastUpdate = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const base_react_components_1 = require("@navinc/base-react-components");
const credit_score_box_1 = __importDefault(require("./credit-score-box"));
const last_updated_1 = __importDefault(require("../../../components/last-updated"));
const scoring_model_1 = require("../../../utils/scoring-model");
const FlexHeader = styled_components_1.default.div.withConfig({ displayName: "reports-FlexHeader", componentId: "reports-1vdi3f3" }) `
  display: flex;
  justify-content: space-between;
`;
exports.LastUpdate = styled_components_1.default.div.withConfig({ displayName: "reports-LastUpdate", componentId: "reports-krldf3" }) `
  padding: 24px 0;
`;
const BureauScoreOverview = ({ bureauSlug, scoreType, hasMatch, reportDate, score, }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const scoringModel = (0, scoring_model_1.getScoringModel)(bureauSlug, scoreType);
    const bureauDisplayNameWithType = scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.displayNameWithType;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FlexHeader, { as: base_react_components_1.Link, "data-testid": `credit-reports:score-overview:${bureauSlug}`, href: `/partner/reports/${bureauSlug}/${pathname.includes('/summary') ? 'overview' : 'summary'}` },
            react_1.default.createElement("div", null,
                react_1.default.createElement(base_react_components_1.Copy, { bold: true, size: "sm" }, bureauDisplayNameWithType),
                react_1.default.createElement(base_react_components_1.Copy, { light: true, size: "xs" }, scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.reportableType)),
            !!score && !!hasMatch && react_1.default.createElement(credit_score_box_1.default, { bureau: bureauSlug, scoreType: scoreType, score: score, withLink: true })),
        !!reportDate && !!hasMatch && (react_1.default.createElement(exports.LastUpdate, { "data-testid": `credit-reports:last-update:${bureauSlug}` },
            react_1.default.createElement(last_updated_1.default, { date: reportDate }))),
        react_1.default.createElement(base_react_components_1.Divider, null)));
};
exports.BureauScoreOverview = BureauScoreOverview;
exports.default = exports.BureauScoreOverview;
//# sourceMappingURL=bureau-score-overview.js.map